
import { defineComponent, ref, watch } from 'vue';
import { debounce, cloneDeep } from 'lodash';
import { useStore } from '@/store';
import { createEnumerableEnum, useStoreGetterOrDefault } from '@/utils';
import { DistanceUnits } from '@/enums';
import { formDefaults } from '@/constants';
import NumberWithMetricInput from '@/components/form-controls/NumberWithMetricInput.vue';
import TextInput from '@/components/form-controls/base/TextInput.vue';
import CheckboxInput from '@/components/form-controls/base/CheckboxInput.vue';
import NumberInput from '@/components/form-controls/base/NumberInput.vue';
import ButtonInput from '@/components/form-controls/base/ButtonInput.vue';
import DefaultOrCustomValueInput from '@/components/form-controls/DefaultOrCustomValueNumberInput.vue';
import CheckboxWithUnit from '@/components/form-controls/base/CheckboxWithUnit.vue';
import NumberWithUnit from '@/components/form-controls/base/NumberWithUnit.vue';

export default defineComponent({
  name: 'AppDefaultsManager',
  components: {
    NumberWithMetricInput,
    TextInput,
    CheckboxInput,
    CheckboxWithUnit,
    NumberInput,
    ButtonInput,
    DefaultOrCustomValueInput,
    NumberWithUnit
  },
  setup() {
    const store = useStore();
    const enumerableDistanceUnits = createEnumerableEnum(DistanceUnits);
    const appDefaults = useStoreGetterOrDefault(() => store.getters.appDefaults.get[0], formDefaults.appDefaults);
    const localAppDefaultsState = ref({
      ...cloneDeep(appDefaults.value),
      minTime: appDefaults.value.minTime !== undefined ? appDefaults.value.minTime : 0
    });

    watch(appDefaults, () => {
      localAppDefaultsState.value = {
        ...cloneDeep(appDefaults.value),
        minTime: appDefaults.value.minTime !== undefined ? appDefaults.value.minTime : 0
      };
    });

    const label = ref('Save');
    const revertLabel = debounce(
      () => {
        label.value = 'Save';
      },
      1500,
      {
        leading: false,
        trailing: true
      }
    );
    const saveAppDefaults = async () => {
      await store.dispatch.appDefaults.update(localAppDefaultsState.value);
      label.value = 'Saved!';
      revertLabel();
    };

    return {
      label,
      localAppDefaultsState,
      enumerableDistanceUnits,
      saveAppDefaults
    };
  }
});
